import httpClient from '@/libs/http-client'
import { HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'

export function requestCapture (aid, bAB = false) {
  const config = {
    headers: {
      [HTTP_HEADER_SKIP_ERROR]: '1'
    }
  }

  const url = `/samsung/capture/${aid}`

  return httpClient.post(url, { aid, bAB }, config).then(response => {
    return response.data.result.data
  })
}

export function getCaptureStatus (id, uuid) {
  const config = {
    headers: {
      [HTTP_HEADER_SKIP_ERROR]: '1'
    }
  }

  const url = `/samsung/capture/get_capture_status/${id}/${uuid}`

  return httpClient.get(url, config).then(response => {
    return response.data.result.data
  })
}

export function requestPreviewCapture (data) {
  const url = '/samsung/capture/preview'

  return httpClient.post(url, data).then(response => {
    return response.data.result.data
  })
}

export function getPreviewCaptureStatus (id, uuid) {
  const url = `/samsung/capture/preview_status/${id}/${uuid}`

  return httpClient.get(url).then(response => {
    return response.data.result.data
  })
}

export function login (param) {
  const url = `/samsung/capture/login`

  return httpClient.post(url, param).then(response => {
    return response.data.result.data
  })
}

export function getResizedImage (param) {
  const url = `/capture/resized_image`

  return httpClient.post(url, param).then(response => {
    return response.data.result
  })
}
